import request from "./request";

// 创建会话
export const createDis = (memoId: any) => {
    return request('post', `/api/excelling/memo/${memoId}/discussion`)
}

// 查询会话详细信息
export const getDisInfo = (memoId: any, discussionId: any, param?: any) => {
    return request('get', `/api/excelling/memo/${memoId}/discussion/${discussionId}`, param);
}

// 创建回复引用发送观点信息
export const postDisContent = (memoId: any, discussionId: any, data: any) => {
    return request('post', `/api/excelling/memo/${memoId}/discussion/${discussionId}`, data);
}

// 获取讨论观点
export const getOptionsByDis = (discussionId: any, params: any) => {
    return request('get', `/api/excelling/memo/discussion/${discussionId}/opinion`, params);
}

// 根据观点获取观点
export const getOptionsByOption = (opinionId: any) => {
    return request('get', `/api/excelling/memo/discussion/opinion/${opinionId}`);
}

// 获取用户
export const getChatInfo = (id:any) => {
    return request('get', `/api/rubik/chat/${id}`);
}